import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { HOJE, humanizeDate } from 'util/date/humanize-date'
import { ListagemDesenvolvimentoInfantilConsultasModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-desenvolvimentoInfantil'

interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSectionProps {
  dataNascimento: LocalDate
  consultas: ListagemDesenvolvimentoInfantilConsultasModel
  iconColor: Color
}

const humanizedDate = (dataNascimento: LocalDate, dataPrimeiraConsulta: LocalDate) => {
  const humanized = humanizeDate(dataNascimento, dataPrimeiraConsulta)
  return humanized === HOJE ? 'Recém nascido' : humanized
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSection({
  dataNascimento,
  consultas,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilConsultasSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='teddyBear' color={iconColor} />
          <Text fontWeight='bold'>Acompanhamento de desenvolvimento infantil</Text>
          <InfoIcon icon='infoCircleFilled' text='Apenas consultas médicas e de enfermagem' />
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Primeira consulta</Text>
          <Text>{formatDate(consultas?.dataPrimeiraConsulta)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Idade na primeira consulta</Text>
          <Text>{humanizedDate(dataNascimento, consultas?.dataPrimeiraConsulta)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas até 2 anos (quantidade)</Text>
          <Text>{consultas?.qtdConsultas ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
